import {
  BatchStatisticsDeletePredefinedItemRequest,
  BatchStatisticsDeletePredefinedItemRequestToJSON
} from '@/api/models/batch/BatchStatisticsDeletePredefinedItemRequest'
import * as runtime from '@/api/runtime'

export class BatchStatisticsDeletePredefinedItemApi extends runtime.BaseAPI {
  /**
   * 定義済み帳票削除
   * @param request
   */
  async deletePredefinedItem(
    request: BatchStatisticsDeletePredefinedItemRequest
  ): Promise<runtime.VoidApiResponse> {
    const response = await this.requestDelete(
      `/batch/statistics/delete-predefined-item`,
      BatchStatisticsDeletePredefinedItemRequestToJSON(request)
    )

    return new runtime.VoidApiResponse(response)
  }
}
